import { render } from "./RecepcionInforme.vue?vue&type=template&id=76a87dce"
import script from "./RecepcionInforme.vue?vue&type=script&lang=js"
export * from "./RecepcionInforme.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/informes/RecepcionInforme.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76a87dce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76a87dce', __exports__)) {
    api.reload('76a87dce', __exports__)
  }
  
  module.hot.accept("./RecepcionInforme.vue?vue&type=template&id=76a87dce", () => {
    api.rerender('76a87dce', render)
  })

}


export default __exports__